import OpenInNew from '@mui/icons-material/OpenInNew';
import { useTheme } from '@mui/material';
import Chip from '@mui/material/Chip';
import { alpha } from '@mui/material/styles';
import { memo, useCallback } from 'react';

interface LinkChipProps {
  label: string;
  href: string;
  target?: string;
}

const LinkChip = memo(function LinkChip({
  label,
  href,
  target = '_blank',
}: LinkChipProps) {
  const theme = useTheme();

  const handleClick = useCallback(() => {
    window.open(href, target);
  }, [href, target]);

  const blue = theme.brandV2.colors.treadBlue;

  return (
    <Chip
      label={label}
      size="small"
      variant="outlined"
      onClick={handleClick}
      onDelete={handleClick}
      deleteIcon={<OpenInNew sx={{ fontSize: 14 }} />}
      sx={{
        color: blue,
        backgroundColor: alpha(blue, 0.06),
        borderColor: alpha(blue, 0.2),
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: '12px',
        '& .MuiChip-deleteIcon': {
          color: blue,
          fontSize: 14,
          '&:hover': {
            color: blue,
          },
        },
        '&:hover': {
          backgroundColor: alpha(blue, 0.12),
          borderColor: alpha(blue, 0.4),
        },
      }}
    />
  );
});

export default LinkChip;
